/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EmployeeModel } from '../models/employee-model';
import { getAttorney$Json } from '../fn/attorney/get-attorney-json';
import { GetAttorney$Json$Params } from '../fn/attorney/get-attorney-json';
import { getAttorney$Plain } from '../fn/attorney/get-attorney-plain';
import { GetAttorney$Plain$Params } from '../fn/attorney/get-attorney-plain';
import { getAttorneys$Json } from '../fn/attorney/get-attorneys-json';
import { GetAttorneys$Json$Params } from '../fn/attorney/get-attorneys-json';
import { getAttorneys$Plain } from '../fn/attorney/get-attorneys-plain';
import { GetAttorneys$Plain$Params } from '../fn/attorney/get-attorneys-plain';

@Injectable({ providedIn: 'root' })
export class AttorneyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAttorneys()` */
  static readonly GetAttorneysPath = '/api/Attorney';

  /**
   * get all attorney.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAttorneys$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttorneys$Plain$Response(params?: GetAttorneys$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeModel>>> {
    return getAttorneys$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get all attorney.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAttorneys$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttorneys$Plain(params?: GetAttorneys$Plain$Params, context?: HttpContext): Observable<Array<EmployeeModel>> {
    return this.getAttorneys$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EmployeeModel>>): Array<EmployeeModel> => r.body)
    );
  }

  /**
   * get all attorney.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAttorneys$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttorneys$Json$Response(params?: GetAttorneys$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeModel>>> {
    return getAttorneys$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get all attorney.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAttorneys$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttorneys$Json(params?: GetAttorneys$Json$Params, context?: HttpContext): Observable<Array<EmployeeModel>> {
    return this.getAttorneys$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EmployeeModel>>): Array<EmployeeModel> => r.body)
    );
  }

  /** Path part for operation `getAttorney()` */
  static readonly GetAttorneyPath = '/api/Attorney/{attorneyId}';

  /**
   * get attorney by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAttorney$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttorney$Plain$Response(params: GetAttorney$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeModel>> {
    return getAttorney$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get attorney by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAttorney$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttorney$Plain(params: GetAttorney$Plain$Params, context?: HttpContext): Observable<EmployeeModel> {
    return this.getAttorney$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmployeeModel>): EmployeeModel => r.body)
    );
  }

  /**
   * get attorney by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAttorney$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttorney$Json$Response(params: GetAttorney$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeModel>> {
    return getAttorney$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get attorney by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAttorney$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttorney$Json(params: GetAttorney$Json$Params, context?: HttpContext): Observable<EmployeeModel> {
    return this.getAttorney$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmployeeModel>): EmployeeModel => r.body)
    );
  }

}
